import React, {useEffect, useState} from "react";
import { LineChart} from "@mui/x-charts"; // Retaining LineChart import
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { Button, Card, Menu, MenuItem , CardActions, CardContent, FormControl, InputLabel, Select, Typography, Box, CardHeader, Stack, Divider } from "@mui/material";
import { CardTravel } from "@mui/icons-material";
import { MONTHS } from "../../Static/static";
import { DateTime } from "luxon";
import { TimeIcon } from "@mui/x-date-pickers";


// I will present sessios
// Per location: 
//    - Session count
//    - Sessions average
//    - Session min and max
//    - Session student attendance sum
//    - Session student attendance average

/**
 * * GET: /assessment_bchart
 * @params: {id AS admin_id, organization_id}
 * */
const chartSetting = {
  yAxis: [
    {
      label: 'Count (int)',
    },
  ],
  width: 700,
  height: 400,
  sx: {
    [`.${axisClasses.left} .${axisClasses.label}`]: {
      transform: 'translate(-20px, 0)',
    },
  },
};

const SessionsBChart = ({ data }) => {
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [filteredData, setFilteredData] = useState(data);
  const [xAxis, setXAxis] = useState([{scaleType: 'band', dataKey: 'month'}]);

  const handleChange = (event) => {
    setSelectedMonth(event.target.value);
    transformData(event.target.value);
  };

  useEffect(() => {
    if (data) {
      console.log(data);
      setFilteredData(data);
      setXAxis([{scaleType: 'band', dataKey: 'month'}])
    }else {
      setFilteredData([]);
    }
  }, [data])

  const transformData = (selectedMonth) => {
    if (!data) { 
      setFilteredData([]);
      return;
    }
    if (selectedMonth) {
      const filtered = data.filter(item => selectedMonth.trim().toLowerCase() == item.month.trim().toLowerCase())
      // When filtering by month, the x-axis data key changes to 'session_date'
      setXAxis([{ scaleType: 'band', dataKey: 'session_date' }]); 
      setFilteredData(filtered)
    }else {
      // When showing all data, the x-axis data key is 'month'
      setFilteredData(data);
      setXAxis([{scaleType: 'band', dataKey: 'month'}]) 

    }
  }


  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 1 }}>
        <Stack direction={"row"} spacing={2} sx={{display: 'flex', alignItems: 'center'}}>
          <Box>
          <Typography variant="h6" fontWeight="bold">
            Sessions Completed by Date
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            View session metrics aggregated by month
          </Typography>
          </Box>
        </Stack>
        <Divider />
      </Box>
  
    {/* Month Selector */}
    <FormControl fullWidth sx={{ mb: 2, maxWidth: 150 }}>
      <InputLabel>Filter by Month</InputLabel>
      <Select
        size="small"
        value={selectedMonth}
        onChange={handleChange}
        label="Filter by Month"
        variant="outlined"
      >
        <MenuItem value={null}>
          <em>All Months</em>
        </MenuItem>
        {MONTHS.map((month, index) => (
          <MenuItem key={month} value={month}>
            {month}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  
    {/* Chart */}
    <Box sx={{ height: 380 }}>
      <LineChart
        dataset={filteredData}
        xAxis={[{
          scaleType: 'band',
          dataKey: selectedMonth ? 'session_date' : 'month',
          tickLabelStyle: {
            angle: selectedMonth ? 45 : 0,
            textAnchor: selectedMonth ? 'start' : 'middle',
            fontSize: '0.65rem'
          }
        }]}
        yAxis={[{
          label: 'count'
        }]}
        series={[
          {
            dataKey: 'total_sessions',
            label: 'Total Sessions',
            showMark: true,
            area: true 
          },
          {
            dataKey: 'total_students',
            label: 'Total Students',
            showMark: true,
          },
          {
            dataKey: 'min_students',
            label: 'Min Students',
            showMark: true,
          },
          {
            dataKey: 'max_students',
            label: 'Max Students',
            showMark: true,
          }
        ]}
        margin={{ top: 65, right: 20, left: 60, bottom: 40 }}
      />
    </Box>
  </Box>

  );
};

export default SessionsBChart;